import { useAtomValue } from 'jotai';

import Item from './item';

import { vendorPlacesQuery } from '../../../../../../store';

import type { Place } from '@rewardopl/types';

type ItemsProps = {
  selectedPlaceId: Place['_id'] | null;
  setSelectedPlaceId: React.Dispatch<React.SetStateAction<Place['_id'] | null>>;
};

export default function Items({ selectedPlaceId, setSelectedPlaceId }: ItemsProps) {
  const places = useAtomValue(
    vendorPlacesQuery({
      includePlacesWithoutLocation: true,
    }),
  );

  return places
    ? places.map((place) => (
        <Item
          isSelected={place._id === selectedPlaceId}
          key={place._id}
          onClick={() => setSelectedPlaceId(place._id)}
          place={place}
        />
      ))
    : null;
}
